class VideoPopup extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.modal = this.querySelector('.modal');
    this.modalDialog = this.querySelector('.modal-dialog');
    this.modalSwiperWrap = this.querySelector('[data-modal-swiper]');
    this.modalSwiper = new Swiper(this.modalSwiperWrap, {
      speed: 300,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      direction: 'vertical',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: {
          direction: 'vertical',
        },
        1024: {
          direction: 'horizontal',
        }
      },
      on: {
        slideChange: () => {
          if (this.videos) {
            this.videos.forEach((video) => {
              video.pause()
            });
            setTimeout(() => {
              const activeVideo = this.modalSwiperWrap.querySelector(`.swiper-slide-active video`);
              if (activeVideo) {
                activeVideo.load();
                activeVideo.controls = true;
              }
            }, 100);
          }
        },
      },
    });
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      speed: 300,
      spaceBetween: 12,
      slidesPerView: 2.5,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 2.5,
          spaceBetween: 12
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 15
        }
      },
    });
    this.socials = this.querySelectorAll('.video-popup--social');
    this.socials.forEach((social) => {
      social.addEventListener('click', (e) => e.stopPropagation())
    });
    this.videos = this.querySelectorAll('video');
    this.clickables = this.querySelectorAll('.youtube-embed');
    this.clickables.forEach((clickable) => {
      clickable.addEventListener('click', () => {
        const index = clickable.dataset.index;
        this.modalSwiper.slideToLoop(index);
        this.videos.forEach((video) => {
          video.pause()
        });
        const activeVideo = this.modalSwiperWrap.querySelector(`.swiper-slide[data-index="${index}"] video`);
        activeVideo.load();
        activeVideo.play();
        jQuery(this.modal).modal('show');
      })
    });
    this.videos.forEach((v) => {
      v.pause();
      v.muted = false;
      v.addEventListener('mouseenter', () => {
        v.controls = true
      });
    });
    jQuery(this.modalDialog).on('click', (e) => {
      if(e.target == e.currentTarget) {
        jQuery(this.modal).modal('hide');
      }
    });
    jQuery(this.modal).on('show.bs.modal', () => {
      let shogunRoot = document.querySelector('.shogun-root')
      console.log('shogunRoot',shogunRoot)
      if (shogunRoot) {
        shogunRoot.style.zIndex = 'initial'
        shogunRoot.style.isolation = 'initial'
      }
    })
    jQuery(this.modal).on('shown.bs.modal', () => {
      this.modalSwiper.animating = false;
    })

    setTimeout(() => {
      jQuery(this.modal).on('hidden.bs.modal', () => {
        this.videos.forEach((video) => {
          video.controls = false;
          video.pause()
        })
        let shogunRoot = document.querySelector('.shogun-root')
        if (shogunRoot) {
          shogunRoot.style.zIndex = '1'
          shogunRoot.style.isolation = 'isolate'
        }
      });
    }, 500);
  }  
}

customElements.define('video-popup', VideoPopup);